export const getWhatsappHref = value => `https://wa.me/${value.replace(/[^\d]/g, '')}`

export const handleContactAction = contact => {
  if (contact.type === 'whatsapp') {
    window.open(getWhatsappHref(contact.value), '_blank', 'noopener,noreferrer')
    return false
  }
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(contact.value)
  }
  return true
}
